"use client";

import { motion, Variants } from "framer-motion";
import Link from "next/link";
import { faLocationDot } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
interface MapButtonProps {
  href: string;
  mapName: string;
  className?: string;
}

/**

 */
const MapButton = ({ href, mapName, className }: MapButtonProps) => {
  const contentVariants: Variants = {
    initial: { y: 0 },
    hover: {
      y: -2,
      transition: { type: "spring", stiffness: 500, damping: 30 },
    },
  };

  return (
    <motion.div
      className={`inline-block`}
      whileHover={{
        scale: 1.05,
        transition: { duration: 0.2 },
      }}
      whileTap={{ scale: 0.95 }} // 클릭 시 미세하게 축소
    >
      <Link
        href={href}
        // 기본 디자인 스타일
        className={`flex items-center space-x-2 border border-midGray-40 pt-3 pb-3 md:px-6 px-4 rounded-full transition-colors hover:bg-light-10 duration-200 ${className}`}
        style={{ fontFamily: '"paperlogy-Medium", sans-serif' }}
      >
        <motion.div
          variants={contentVariants}
          initial="initial"
          animate="initial"
          whileHover="hover"
          className="flex items-center space-x-2"
        >
          <FontAwesomeIcon
            icon={faLocationDot}
            className="md:text-xl text-[15px]  text-black-200"
          />
          <span className="md:text-xl text-[15px] tracking-tight md:leading-7 leading-5 text-black-200">
            {mapName}
          </span>
        </motion.div>
      </Link>
    </motion.div>
  );
};

// ⭐ 메인 컴포넌트
export default function WezonDirection() {
  const address = "대전광역시 중구 중앙로 124 이화빌딩 2층";

  // 지도 서비스별 검색 URL (주소는 URL 인코딩 필요)
  const encodedAddress = encodeURIComponent(address);
  const naverMapUrl = `https://map.naver.com/v5/search/${encodedAddress}`;
  const kakaoMapUrl = `https://map.kakao.com/?q=${encodedAddress}`;

  return (
    <div className="border-t border-[#ECECEC] mt-[-2px]">
      <div className="w-full xl:max-w-[1280px] mx-auto px-5 xl:px-2 py-14 md:py-24">
        <div className="flex mx-auto flex-col text-center md:mt-20 mt-10 md:mb-10 mb-8">
          <p
            className="md:text-2xl text-base tracking-tighter text-lightGray-10"
            style={{ fontFamily: '"paperlogy-Light", sans-serif' }}
          >
            Wezon Direction Guidance
          </p>
          <div className="flex  items-center  justify-center md:mt-10 mt-5  md:mb-5 mb-2 md:text-5xl text-2xl md:leading-14 leading-8 tracking-tighter text-lightGray-10 gap-x-2">
            <p
              className="text-black-almostBlack"
              style={{ fontFamily: '"pre-Medium", sans-serif' }}
            >
              찾아오시는 길
            </p>
            <p
              className="text-black-almostBlack"
              style={{ fontFamily: '"pre-Regular", sans-serif' }}
            >
              {" "}
              안내
            </p>
          </div>
          <p
            className="text-black-100 md:text-2xl text-lg tracking-tighter"
            style={{ fontFamily: '"pre-Medium", sans-serif' }}
          >
            {address}
          </p>
        </div>
        <div className=" mx-auto text-center md:space-x-7 space-x-2">
          <MapButton href={naverMapUrl} mapName="네이버 지도" />
          <MapButton href={kakaoMapUrl} mapName="카카오맵" />
        </div>
        <div className="w-full max-w-[1146px] aspect-[1146/654] relative mx-auto md:my-20 my-10">
          <Image
            src="/assets/images/page/service/des/img.png"
            alt="background"
            fill
            className="object-cover md:object-contain"
          />
        </div>
      </div>
    </div>
  );
}
